/* eslint-disable jsx-a11y/no-onchange */
import React from 'react';
import PropTypes from 'prop-types';
import './radio-group.scss';

export const SelectComponent = ({
  label, required, radioValues, name, onChange, error, errorMessage, disabled,
}) => (
  <div className='nmx-form__input' role='radiogroup'>
    {label}{required && <span>&#42;</span>}
    <fieldset aria-required={required}>
      <legend>{label}</legend>
      {
        radioValues.map(radioValue => (
          <label aria-label={radioValue} key={radioValue}>
            <span className='nmx-form__radio-button-label'>{radioValue}</span>
            <input
              type='radio'
              name={name}
              disabled={disabled}
              value={radioValue}
              onChange={onChange}
            />
          </label>
        ))
      }
      {error && <small className='nmx-form__validation-error'>{errorMessage || 'Error'}</small>}
    </fieldset>
  </div>
);

SelectComponent.propTypes = {
  /** The label placed on the text field */
  label: PropTypes.string.isRequired,
  /** Name applied to input or textarea */
  name: PropTypes.string.isRequired,
  /** String array of radio buttons for group, each string is used as both the display label and value */
  radioValues: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  /** Is this input in an error state */
  error: PropTypes.bool,
  /** Message to display when error is true */
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
};

SelectComponent.defaultProps = {
  radioOptions: [],
  onChange: () => {},
  disabled: false,
  error: false,
  errorMessage: 'Error',
  required: false,
};

export default SelectComponent;
